import React from 'react';

const RunoutCard = ({
  suit,
  rank = 'A',
  dealDelayMs,
  startX,
  flipDurationMs,
  slideDurationMs,
}) => {
  const isRed = suit === '♥' || suit === '♦';
  return (
    <div
      className="deal-card"
      /* eslint-disable-next-line react/style-prop-object */
      style={{
        '--deal-delay': `${dealDelayMs}ms`,
        '--start-x': `${startX}px`,
        '--start-y': '0px',
        '--flip-duration': `${flipDurationMs}ms`,
        '--slide-duration': `${slideDurationMs}ms`,
      }}
    >
      <div className="card-inner">
        <div className="card-face card-front">
          <div className="poker-card">
            <div className="corner top-left">
              <span className="rank">{rank}</span>
              <span className={`suit ${isRed ? 'red' : ''}`}>{suit}</span>
            </div>
            <div className="corner bottom-right">
              <span className="rank">{rank}</span>
              <span className={`suit ${isRed ? 'red' : ''}`}>{suit}</span>
            </div>
            <div className={`center-suit ${isRed ? 'red' : ''}`}>{suit}</div>
          </div>
        </div>
        <div className="card-face card-back" />
      </div>
    </div>
  );
};

export default RunoutCard;


